var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container bg-white"},[_c('h2',{staticClass:"title-text"},[_vm._v("Why you should join Project Athena...")]),_c('youtube',{attrs:{"video-id":_vm.videoId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }